import React from 'react';
import PortfolioBlock from "./PortfolioBlock";
import {Box, Grid} from "@mui/material";
import {info} from "../../info/Info";
import styles from './Portfolio.module.scss';

export default function Portfolio({innerRef, darkMode}) {
    return (
        <Box id={'portfolio'} ref={innerRef} className={styles.portfolioContainer}>
            <h2 
                className={styles.sectionHeading}
                style={{
                    color: darkMode ? '#f5f5f5' : '#1a1a1a',
                    border: `2px solid ${darkMode ? 'rgba(65, 105, 225, 0.3)' : 'rgba(65, 105, 225, 0.5)'}`,
                    background: darkMode 
                        ? 'linear-gradient(135deg, rgba(65, 105, 225, 0.1), rgba(147, 51, 234, 0.1))'
                        : 'linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(240, 240, 255, 0.9))',
                    boxShadow: darkMode 
                        ? '0 8px 25px rgba(0, 0, 0, 0.3)' 
                        : '0 8px 25px rgba(65, 105, 225, 0.15)',
                }}
            >
                Portfolio
            </h2>
            <Grid container display={'flex'} justifyContent={'center'}>
                {info.portfolio.map((project, index) => (
                   <Grid item xs={12} md={6} key={index}>
                       <PortfolioBlock 
                           image={project.image}
                           live={project.live}
                           source={project.source}
                           title={project.title}
                           darkMode={darkMode}
                       />
                   </Grid>
                ))}
            </Grid>
        </Box>
    );
}